(ns app.front.view.group.admin.inspections.templates-common
  (:require [app.front.entities :as entities]
            [app.front.util :as futil]
            [core.front.event :refer [>evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

;;; Util functions
;;;;;;;;;;





(defn set-value-fn [key]
  (fn [db [_ id updates]]
    (if (= id (-> db key :db/id))
      (reduce (fn [db [path value]]
                (let [path (if (vector? path) path [path])]
                  (assoc-in db (cons key path) value))) db updates)
      ;; don't update if entity-under-edit is different
      db)))

(defn save-value-handler-fn [command]
  (fn [_ [_ id values {:keys [on-success notify]}]]
    (when id
      (let [new-values-for-entity (map (fn [[path value]]
                                         {:id id :attr path :value value})
                                       values)]
        {:comm/command (p/assoc-if {:command    command
                                    :data       {:data new-values-for-entity
                                                 :id   id}
                                    :on-success [::entities/apply-changes]}
                                   :on-success  on-success
                                   :notify      notify)}))))

(defn save-handler-fn [command link-to-id-key submit-keys on-success]
  (fn [_ [_ link-to-id data]]
    {:comm/command {:command    command
                    :data       {link-to-id-key link-to-id
                                 :data          (select-keys data
                                                             submit-keys)}
                    :on-success [on-success]}}))

(defn save-done-handler-fn [then-dissoc]
  (fn [{:keys [db]} [_ status changes]]
    {:db         (dissoc db then-dissoc)
     :dispatch-n [[:notifications/add :toast :success :changes-saved :changes-saved]
                  [::entities/apply-changes status changes]]}))

(rf/reg-event-fx ::delete-entity-success
  (fn [_ [_ entity-id _ _]]
    (>evt [::entities/remove-entity entity-id])))

(defn delete-entity [command]
  (fn [_ [_ id]]
    {:comm/command {:command    command
                    :data       {:entity-id id}
                    :on-success [::delete-entity-success id]}}))

;;; Components
;;;;;;;;;;

(defn editor-props [tr id key disp-on-change disabled & [coercer]]
  {:id         (-> key name (str id))
   :label-text (tr [key])
   :required   true
   :disabled   disabled
   :on-change  #(rf/dispatch-sync
                  [disp-on-change
                   id
                   [[key
                     (-> % futil/tval ((or coercer identity)))]]])})

(defn simple-editor [{:keys [set-value-event save-value-event]}
                     {:keys [tr item id disabled]}
                     component
                     attr
                     & [coercer]]
  (let [c           (if (vector? component) (first component) component)
        extra-props (if (vector? component) (second component) {})]
    [c
     (merge (editor-props tr id attr set-value-event disabled coercer)
            {:value   (get item attr)
             :on-blur #(>evt [save-value-event
                              id
                              [[attr
                                (-> %
                                    futil/tval
                                    ((or coercer identity)))]]])}
            extra-props)]))
